import { ActionTypes } from "./constants";

const setCurrentLocation = (payload) =>({ type: ActionTypes.SET_CURRENT_LOCATION, payload: payload });
const setTempForm = (payload) =>({ type: ActionTypes.SET_TEMP_FORM, payload: payload });

const MgtStationActions = { 
    setCurrentLocation,
    setTempForm
}

export default MgtStationActions
